export default __webpack_public_path__ + "static/media/ketosis_shape@3x.8bd13b17.jpg";